import clsx from "clsx";
import * as React from "react";

type MetalWrapperProps = {
  children: React.ReactNode;
  className?: string;
  variant?: "solid" | "transparent";
  size?: "sm" | "md" | "lg";
};

const baseStyles = "border-2 border-gray-600 rounded-bl-lg rounded-tr-lg";

const variants = {
  solid: "bg-gray-800",
  transparent: "bg-gray-800/50 backdrop-blur-sm",
};

const sizes = {
  sm: "p-3",
  md: "p-6",
  lg: "p-8",
};

export function MetalWrapper({
  children,
  className = "",
  variant = "solid",
  size = "md",
}: MetalWrapperProps) {
  return (
    <div
      className={clsx(baseStyles, variants[variant], sizes[size], className)}
    >
      {children}
    </div>
  );
}
